import React from 'react'
import {Window, Button, LinkButton, Support} from 'common/components'
import {Http, getEnvironment} from 'common'

export default class App extends React.Component {
    state = {
        username: null,
        cabinets: null,
        csrfToken: null
    }

    providers = {
        kyivcity: 'Особистий кабінет киянина'
    }

    messages = {
        authorized: [
            'Модуль авторизації ІТС «Єдина міська платформа електронної взаємодії, управління даними та сервісами» (Київ ID – Єдиний обліковий запис киянина)',
            'Ви маєте можливість увiйти в наступнi електроннi сервіси.'
        ],
        unauthorized: [
            'Модуль авторизації ІТС «Єдина міська платформа електронної взаємодії, управління даними та сервісами» (Київ ID – Єдиний обліковий запис киянина)',
            'Ви маєте авторизуватись для отримання електронних послуг.'
        ]
    }

    componentWillMount() {
        Http.GET('csrf', csrf => {
            this.setState({csrfToken: csrf.token})

            Http.GET('api/session', data => {
                this.setState({...data})
            })
        })
    }


    render() {
        const {BASE_URL, LOGIN_URL, CREDENTIALS_URL} = getEnvironment()
        const {username, cabinets, csrfToken} = this.state
        const authorized = username != null
        const message = authorized ?
            this.messages.authorized : this.messages.unauthorized

        return (
            <div className="content">
                <Window message={message} picture={authorized ? "success" : "laptop"}>
                    <div>
                        {authorized ?
                            <div>
                                {cabinets.map((item, index) => (
                                    <LinkButton key={index} href={item.link} value={this.providers[item.code]} />
                                ))}

                                <LinkButton
                                    href={CREDENTIALS_URL}
                                    value='Редагувати профiль'
                                    style={{marginTop: '5px'}}
                                />

                                <form
                                    action={`${BASE_URL}/logout`}
                                    method='post'
                                    style={{marginTop: '30px'}}
                                >
                                    <Button type='submit' value='Вихiд' />
                                    <input type='hidden' name='_csrf' value={csrfToken||''} />
                                </form>

                            </div>
                            :
                            <LinkButton href={LOGIN_URL} value='Авторизацiя' />
                        }
                        <br />
                    </div>
                </Window>
                <Support />
            </div>
        )
    }
}

